import actions from './appActions';
import mutations from './appMutations';

const initialState = {
  submitProtection: false,
  configuration: null,
  loadingData: {
    users: false,
    customers: false,
    priceLists: false,
    codeListItems: false,
    orders: false,
    deliveryNotes: false,
    invoiceData: false
  }
};

export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  actions: actions
}



// WEBPACK FOOTER //
// ./client/store/modules/app/index.js